module.exports = __webpack_public_path__ + "static/media/22-5.be794b81.mp3";